import { fetchSubscriptionDetails } from "@dashboard/orders/views/OrderSubscriptions/api";
import { SubscriptionRow } from "@dashboard/orders/views/OrderSubscriptionsList/OrderSubscriptionsList.utils";
import React from "react";

export const useSubscriptionDetails = (subscriptionId: string) => {
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);
  const [subscription, setSubscription] =
    React.useState<SubscriptionRow | null>(null);
  const [notFound, setNotFound] = React.useState(false);
  const [reloadKey, setReloadKey] = React.useState(0);

  const reload = React.useCallback(() => {
    setReloadKey(prev => prev + 1);
  }, []);

  React.useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);
      setNotFound(false);

      try {
        const item = await fetchSubscriptionDetails(subscriptionId);

        if (!cancelled) {
          setSubscription(item);
          setNotFound(item === null);
        }
      } catch (e) {
        if (!cancelled) {
          setError(e instanceof Error ? e.message : "Unknown error");
          setSubscription(null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    void load();

    return () => {
      cancelled = true;
    };
  }, [subscriptionId, reloadKey]);

  return { loading, error, subscription, notFound, reload };
};
